<template>
	<div class="newproducthome">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="banner" v-if="info">
        <swiper id="swiperBanner" v-if="info.bannerlist.length" :options="bannerSwiper" style="height: 100%;">
          <swiper-slide v-for="(item, index) of info.bannerlist" :key="index">
            <img :src="item.img_path">
            <div :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=1'" class="slide_cl_xcx" v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"></div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" id="bannerSwiperPagination"></div>
      </div>
      <van-notice-bar v-if="info && info.topmsglist.length" class="notice-bar" left-icon="/static/images/newproducttrial/new_product-icon-notice@2x.png" :scrollable="false">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, index) of info.topmsglist" :key="index" class="f13 flex-ac">恭喜<span class="f13">&nbsp;{{item.username}}&nbsp;</span>成功申请<span class="f13">*{{item.totalnum}}</span></van-swipe-item>
        </van-swipe>
      </van-notice-bar>
      <div class="integral flex-ac f12" v-if="info" @click="$router.push('/integralTask')">
        <img src="/static/images/newproducttrial/new_product-icon-money@2x.png">
        x<b>{{info.limitpoint}}</b>&nbsp;<span class="f10 color-9">剩余</span>
        <p class="f11 flex-ac">获得金币<van-icon name="arrow" size="0.12rem" color="#222222"/></p>
      </div>
      <div class="list">
      <van-tabs v-model="navIndex" @click="navClick">
        <van-tab v-for="(item, index) of nav" :key="index" :title="item"></van-tab>
        <div class="listBox" v-if="navIndex == 0">
          <new-product-item v-for="(item, index) of list" :key="index" :productItem="item"></new-product-item>
        </div>
        <div class="communitylist" v-else>
          <div class="listItem" ref="listItem1">
            <community-item v-for="(item, index) in list1" :prolistItem="item" :key="index"></community-item>
          </div>
          <div class="listItem" ref="listItem2">
            <community-item v-for="(item, index) in list2" :prolistItem="item" :key="index"></community-item>
          </div>
        </div>
        <div class="noData" v-if="empty && navIndex == 1" :style="{'height': emptyHeight/100 + 'rem', 'padding': '0.1rem 0.11rem'}">
          <img src="../../assets/images/emptyorder.png" />
          <p class="f14 color-29">糟糕！暂无试用体验反馈～</p>
          <p @click="navIndex = 0;nowPage = 1;getData()">去新品试用逛逛></p>
        </div>
      </van-tabs>
    </div>
    </Scroller>
    <div class="floatbtn">
      <img v-if="isnewpersontask" @click="newpersontask" src="/static/images/new-person/newpersontask@2x.png">
      <img @click="$router.push('/applyrecord')" src="/static/images/newproducttrial/new_product-icon-apply_record@2x.png">
      <img @click="$router.push('/')" src="/static/images/newproducttrial/new_product-icon-home_page@2x.png">
      <img @click="$router.push('/ordsealist?trialorder=1')" src="/static/images/newproducttrial/new_product-icon-trial_experience@2x.png">
    </div>
  </div>
</template>

<script>
import newProductItem from '../common/newProductItem'
import communityItem from '../common/communityItem'
import Scroller from '../common/Scroller'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */)

export default {
  name: "newproducthome",
  components: {
    newProductItem,
    communityItem,
    Scroller,
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  data () {
    var that = this
    return {
      bannerSwiper: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        initialSlide: 0,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        watchOverflow: true,
        pagination: {
          el: '#bannerSwiperPagination',
          // clickable: true,
          type: 'bullets'
        },
        on: {
          slideChangeTransitionStart: function () {
            // that.activeIndex = this.realIndex
          },
          click: function () {
            var activeIndex = this.realIndex
            that.bannerClick(that.info.bannerlist[activeIndex], activeIndex, 'banner-' + (activeIndex + 1))
          }
        }
      },
      isWx: isWeixin() ? 1 : 0,
      info: null,
      nav: ['新品试用', '试用体验'],
      navIndex: 0,
      list: [],
      list1: [],
      list2: [],
      nowPage: 0,
      refresh: false,
      loading: false,
      finished: false,
      empty: false,
      emptyHeight: 0,
      isnewpersontask: 0,
      newpersonjump: ''
    }
  },
  mounted: function () {
    // this.getHome()
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        vm.getHome()
      })
    } else {
      next(vm => {
        vm.getHome()
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getHome: function () {
      var url = 'Wxmall/NewItem/getIndex'
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == '200') {
          this.info = res.data.data
          this.$nextTick(() => {
            setTimeout(() => {
              let banner_h = document.getElementsByClassName('banner')[0].clientHeight,
                noticeBar_h = document.getElementsByClassName('notice-bar') ? document.getElementsByClassName('notice-bar')[0].clientHeight : 0,
                integral_h = document.getElementsByClassName('integral')[0].clientHeight
              this.emptyHeight = document.body.clientHeight - banner_h - noticeBar_h - integral_h - 44
            }, 0)
          })
          if (isWeixin()) {
            fenxiang({
              title: this.info.sharetitle ? encodeURIComponent(this.info.sharetitle) : '',
              desc: this.info.sharedesc ? encodeURIComponent(this.info.sharedesc) : '',
              imgx: this.info.shareimg ? this.info.shareimg : '',
              type: 'newproducthome',
              dataStr: 'type=newproducthome',
              path: 'newproducthome'
            })
          }
        }
      })
      this.$newuserFn((data) => {
        if (data.code == 200) {
          this.isnewpersontask = data.isnewpersontask
          this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
        }
      })
    },
    getData: function () {
      var url = 'Wxmall/NewItem/getActivitylist'
      if (this.navIndex == 1) {
        url = 'Wxmall/NewItem/getFeedbackList'
      }
      url= url + '?pageNo=' + this.nowPage + '&pageSize=' + this.pagesize
      this.$customRequestAjax(url)
        .then((res) => {
          if (res.data.code == 200) {
            if (this.nowPage == 1) {
              if (res.data.list.length == 0) this.empty = true
              if (this.navIndex == 0) {
                this.list = res.data.list
              } else {
                this.list1 = []
                this.list2 = []
              }
              this.refresh = false
            } else {
              if (this.navIndex == 0) this.list = this.list.concat(res.data.list)
            }
            if (this.navIndex == 0) this.loading = false
            if (res.data.list.length < this.pagesize) {
              this.finished = true
              if (this.nowPage == 1 && !res.data.list.length && this.navIndex != 0) {
                this.list1 = []
                this.list2 = []
              }
            } else {
              this.finished = false
            }
            if (this.navIndex == 1) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.doSort(0, res.data.list)
                })
              })
            }
          }
        })
    },
    doSort (index, list) {
      let that = this
      if (index < list.length) {
        f()
        function f() {
          if (that.$refs.listItem1.clientHeight <= that.$refs.listItem2.clientHeight) {
            that.list1.push(list[index])
          } else {
            that.list2.push(list[index])
          }
          if (index < list.length - 1) {
            that.loading = true
          } else {
            that.loading = false
          }
          that.$nextTick(() => {
            setTimeout(() => {
              that.doSort(index + 1, list)
            }, 100)
          })
        }
      }
    },
    onRefresh () {
      this.refresh = true
      this.getHome()
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    },
    newpersontask () {
      window.location = this.newpersonjump
    },
    navClick () {
      this.list = []
      this.list1 = []
      this.list2 = []
      this.nowPage = 1
      this.getData()
    },
    bannerClick: function (items, index, flowArea, sorce) {
      if (items.ad_type == 9 || items.ad_type == '10') {
        window.location.href = items.ad_target
        return
      }
      switch (items.ad_type) {
        case '1': // 跳转链接
          if (items.ad_target == 'act') {
            this.moreHot()
          } else {
            if (items.ad_target.indexOf('power-luckdraw.html') >= 0) {
              this.$buriedPoint({
                behavior: '100',
                userfrom: flowArea == '精选活动' ? 3 : 1
              })
            }
            var actid = parseInt(items.activityid)
              ? '?actid=' + items.activityid
              : ''
            if (items.ad_target.indexOf('anniversary-bill-big-swiper')) {
              sessionStorage.removeItem('anniversary-bill-pop-show')
            }
            let pathArr = items.ad_target.split('/')
            if (pathArr[pathArr.length - 1] == 'ylqrcode.html') {
              // 判断跳转链接是否是进入企微二维码页面
              this.$customRequestAjax('Wxmall/Qwqrcode/getQrcode').then((ok) => {
                if (ok.data.data.isRegularUser) {
                  // console.log('你不是普通用户')
                  this.$toast('活动已结束')
                } else {
                  if (ok.data.data.qrcodePath == '') {
                    this.$toast('您没有参与资格')
                  } else {
                    window.location.href = items.ad_target
                  }
                }
              })
            } else {
              window.location.href = items.ad_target + actid
            }
          }
          break
        case '2': // 商品分类
          if (items.ad_target == 0) {
            this.$router.push({
              path: '/classification',
              query: {
                type: 'inside'
              }
            })
          } else {
            this.$store.commit('CATEGORY_ID', items.father_class_id)
            this.$store.commit('CATEGORY_SONID', items.ad_target)
            this.$router.push({
              path: '/productCategory',
              query: {
                title: encodeURIComponent(items.father_class_name)
              }
            })
          }
          break
        case '3': // 商品详情
          this.$router.push({
            path: 'productdetail',
            query: {
              itemid: items.ad_target
            }
          })
          break
        case '4':
          this.$router.push('/')
          break
        case '5':
          this.$router.push('/')
          break
        case '7':
          if (isWeixin()) {
          } else {
            this.$toast('请前往微信搜索小程序「创客云商可丽金官方」')
          }
          break
        case '8':
          if (isWeixin()) {
            if (items.liveroom_qrcode_url) {
              this.liveroom_qrcode_url = items.liveroom_qrcode_url
            }
          } else {
            this.$toast('请前往微信搜索小程序「创客云商可丽金官方」')
          }
          break
        case '12':
          this.$router.push('/actintroduce')
          break
        case '13':
          this.$router.push('/giftbagproduct')
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .newproducthome {
    .banner {
      position: relative;
      /*min-height: 1.92rem;*/
      border-radius: 0 0 100% 100%;
      transition: all 0.5s;
      height: 1.6rem;
      .swiper-wrapper {
        .swiper-slide {
          overflow: hidden;
          /*border-radius: 0.04rem;*/
          height: 1.6rem;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }
      ul {
        padding: 0.51rem 0.1rem 0;
        box-sizing: border-box;
        li {
          overflow: hidden;
          border-radius: 0.04rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    #bannerSwiperPagination {
      width: auto;
      /*background: url(../../assets/images/pagebg.png) no-repeat left top;*/
      /*background-size: 100% 100%;*/
      font-size: 0;
      color: #ffffff;
      /*right: 0.21rem;*/
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      /*padding: 0 0.0385rem 0.01rem;*/
    }
    .notice-bar {
      background: transparent;
      height: 0.14rem;
      padding: 0 0.11rem;
      margin-top: 0.1rem;
      .van-notice-bar__left-icon {
        font-size: 0.4rem;
      }
      .notice-swipe {
        height: 0.2rem;
        line-height: 0.2rem;
        font-size: 0.1rem;
        color: #333333;
        span {
          color: #FF0001;
        }
      }
    }
    .integral {
      height: 0.38rem;
      background: #ffffff;
      border-radius: 0.08rem;
      /*background: url(/static/images/newproducttrial/new_product-money-entrance@2x.png) no-repeat center;*/
      /*background-size: 100%;*/
      padding: 0 0.16rem;
      margin: 0.1rem 0.11rem 0;
      color: #292929;
      position: relative;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.01rem;
      }
      b {
        font-size: 0.22rem;
      }
      p {
        position: absolute;
        right: 0.12rem;
      }
    }
    .list {
      margin-top: 0.1rem;
      .listBox {
        margin: 0 0.11rem 0.1rem;
        .newProductItem {
          margin-top: 0.1rem;
        }
      }
      .communitylist {
        width: 100%;
        padding-right: 0.1rem;
        margin-top: 0.1rem;
        overflow: hidden;
        .listItem {
          padding-left: 0.1rem; // 剧中
          width: 50%;
          float: left;
        }
      }
    }
    .floatbtn {
      position: fixed;
      right: 0.16rem;
      bottom: 0.55rem;
      img {
        width: 0.5rem;
        height: 0.5rem;
        margin-top: 0.07rem;
      }
    }
    .noData {
      margin: 0 0.1rem 0.11rem;
      /*padding: 0.7rem 1.14rem;*/
      background: #fff;
      text-align: center;
      font-size: 0.14rem;
      color: #FC0324;
      border-radius: 0.04rem;
      height: 40%;
      .color-29 {
        color: #292929;
        margin-bottom: 0.08rem;
      }
      img {
        margin: 0.6rem auto 0.16rem;
        width: 1.1rem;
        height: 1.1rem;
      }
    }
  }
</style>
<style lang="scss">
.newproducthome {
  .banner {
    .swiper-container {
      margin: 0;
      position: absolute;
      top: 0;
      width: 100%;
      .swiper-wrapper {
        /*padding: 0 0.1rem;*/
        box-sizing: border-box;
      }
    }
    #bannerSwiperPagination {
      bottom: 0.1rem;
      span {
        margin-left: 0.05rem;
        &.swiper-pagination-bullet {
          width: 0.05rem;
          height: 0.05rem;
          border-radius: 50%;
          background: #FFFFFF;
          opacity: 1;
        }
        &:first-child {
          margin-left: 0;
        }
        &.swiper-pagination-bullet-active {
          background: #FC0324;
        }
      }
    }
  }
  #bannerSwiperPagination {
    text-align: center;
    span {
      margin-left: 0.05rem;
      background: rgba(0, 0, 0, 0.2);
      &.swiper-pagination-bullet-active {
        background: #FC0324;
      }
    }
  }
  .notice-bar {
    .van-notice-bar__left-icon {
      font-size: 0.35rem;
      margin-right: 0.05rem;
    }
  }
  .list {
    .van-tabs__nav--line {
      padding-bottom: 0.1rem;
    }
    .van-tabs__line {
      width: 0.26rem;
      bottom: 0.15rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newproducttrial/home.vue